<template>
  <div class="propertysupervise">
    <div class="header">
      <div class="title">实时社区监管</div>
      <div class="border"></div>
    </div>
    <div class="body">
      <div class="left">
        <div class="logo">
          <img :src="propertysupervise1" alt="" />
        </div>
        <div class="position">
          <img :src="propertysupervise2" alt="" />
          <img :src="propertysupervise3" alt="" />
          <img :src="propertysupervise4" alt="" />
        </div>
      </div>

      <div class="right">
        实时监控管理中心，可启用远程监管，事前预警、事中控制、事后管理，发现问题随时随地快速安排相关工作，在线派单发布任务，提高物业工作效率。
      </div>
    </div>
  </div>
</template>

<script>
import { reactive } from "vue";

import propertysupervise1 from "../../../../assets/product/propertysupervise1.png";
import propertysupervise2 from "../../../../assets/product/propertysupervise2.png";
import propertysupervise3 from "../../../../assets/product/propertysupervise3.png";
import propertysupervise4 from "../../../../assets/product/propertysupervise4.png";

export default {
  setup() {
    return reactive({
      propertysupervise1: propertysupervise1,
      propertysupervise2: propertysupervise2,
      propertysupervise3: propertysupervise3,
      propertysupervise4: propertysupervise4,
    });
  },
};
</script>

<style scoped>
.propertysupervise {
  width: 1180px;
  margin: 80px auto;
}
.header .title {
  font-size: 30px;
  text-align: center;
}
.header .border {
  width: 40px;
  height: 5px;
  background: #248efb;
  margin: 20px auto 0;
}

.body {
  margin-top: 40px;
  display: flex;
  justify-content: space-between;
}
.body .left {
  display: flex;
  position: relative;
}
.body .left .logo img {
  width: 332px;
  margin-right: 20px;
}
.body .left .position img {
  width: 236px;
  position: absolute;
}
.body .left .position img:nth-of-type(1) {
  left: 100%;
}
.body .left .position img:nth-of-type(2) {
  left: 125%;
  bottom: 0;
}
.body .left .position img:nth-of-type(3) {
  left: 150%;
  bottom: 0;
}
.body .right {
    width: 480px;
    font-size: 16px;
    color: #3D3D3D;
    line-height: 24px;
}
</style>
